export enum CompanyType {
    Admin = 1,
    Fleet = 2,
    Basic = 4,
}
